// Функции для вычисления внешних размеров элементов.

/**
 * Посчитать внешнюю ширину элемента без округления
 * 
 * Стандартный метод offsetWidth округляет, причём в меньшую сторону.
 * 
 * @param element Элемент, чтью ширину нужно посчитать
 * @param includeMargin Расчёт с учётом размера margin
 * @returns Внешняя ширина элемента
 */
function calcOuterWidth( element: HTMLElement, includeMargin: boolean = false ): number
{
	const style = window.getComputedStyle( element );
	
	let width: number = parseFloat( style.width || '0' );
	
	if ( includeMargin )
	{
		width += parseFloat( style.marginLeft || '0' )
			+ parseFloat( style.marginRight || '0' );
	}
	
	if ( style.boxSizing !== 'border-box' )
	{
		width += parseFloat( style.borderLeftWidth || '0' )
			+ parseFloat( style.borderRightWidth || '0' )
			+ parseFloat( style.paddingLeft || '0' )
			+ parseFloat( style.paddingRight || '0' );
	}
	
	return width;
}

/**
 * Посчитать внешнюю высоту элемента без округления
 * 
 * Стандартный метод offsetHeight округляет, причём в меньшую сторону.
 * 
 * @param element Элемент, чтью высоту нужно посчитать
 * @param includeMargin Расчёт с учётом размера margin
 * @returns Внешняя высота элемента
 */
function calcOuterHeight( element: HTMLElement, includeMargin: boolean = false ): number
{
	const style = window.getComputedStyle( element );
	
	let height: number = parseFloat( style.height || '0' );
	
	if ( includeMargin )
	{
		height += parseFloat( style.marginTop || '0' )
			+ parseFloat( style.marginBottom || '0' );
	}
	
	if ( style.boxSizing !== 'border-box' )
	{
		height += parseFloat( style.borderTopWidth || '0' )
			+ parseFloat( style.borderBottomWidth || '0' )
			+ parseFloat( style.paddingTop || '0' )
			+ parseFloat( style.paddingBottom || '0' );
	}
	
	return height;
}

/**
 * Модуль
 */
export {
	calcOuterWidth,
	calcOuterHeight,
};



// WEBPACK FOOTER //
// ./utils/nodes/OuterSizes.ts